import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { searchSqlDto, searchSqlModel } from '../../models/base/base';
import { SingleResponseModel } from 'src/app/tabms/models/base/base';

@Injectable({
  providedIn: 'root'
})
export class SqlSearchService {
  private url = environment.baseUrl + this.getResourceUrl();

  constructor(private http: HttpClient) { }

  private getResourceUrl(): string {
    return 'SqlExecution';
  }

  getDataBySqlQuery(query: searchSqlDto): Observable<SingleResponseModel<searchSqlModel<any>>> {
    return this.http.post<SingleResponseModel<searchSqlModel<any>>>(`${this.url}/SearchWithFilterAsync`, query)
  }

  // getNextSerial(tablename: string, fieldname: string, pageparameters: string): Observable<SingleResponseModel<number>> {
  //   let params = { tablename: tablename, fieldname: fieldname };
  //   if (pageparameters) {
  //     params['pageparameter'] = pageparameters;
  //   }
  //   return this.http.get<SingleResponseModel<number>>(`${this.url}/GetNextSerial`, { params });
  // }

  checkIfFieldValueIsDuplicated(tablename: string, fieldname: string, fieldvalue: string, pageparameters: string): Observable<SingleResponseModel<boolean>> {
    let params = { tablename: tablename, fieldname: fieldname, fieldvalue: fieldvalue };
    if (pageparameters) {
      params['pageparameter'] = pageparameters;
    }
    return this.http.get<SingleResponseModel<boolean>>(`${this.url}/IsFieldDuplicated`, { params });
  }

  getMaxSequenceSerial(tablename: string, fieldname: string, pageparameters: string, trxDate: string, reserve = false): Observable<SingleResponseModel<number>> {
    let params = { menukey: tablename, fieldname: fieldname, reserve: reserve };
    if (pageparameters) {
      params['pageparameter'] = pageparameters;
    }
    if (trxDate) {
      params['trxdate'] = trxDate;
    }
    return this.http.get<SingleResponseModel<number>>(`${this.url}/GetMaxSequenceSerial`, { params });
  }

  GetFilterData(systemMenuId, filterdata, pagenumber, pagesize): Observable<SingleResponseModel<searchSqlModel<any>>> {
    //custom filter
    let request = `${this.url}/GetFilterData`;
    let params = { menuid: systemMenuId, filterdata: filterdata, pagenumber: pagenumber, pagesize: pagesize };
    return this.http.get<SingleResponseModel<searchSqlModel<any>>>(request, { params: params });
  }
}
